import { GridRowData } from '@mui/x-data-grid';
import { AxiosResponse, Method } from 'axios';
import { Formik } from 'formik';
import { OptionsObject, SnackbarKey } from 'notistack';
import { React } from 'react';
import { UseMutationResult } from 'react-query';
import { Loadable } from 'recoil';
import { IUserAtom } from 'src/recoil/atoms/user';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import { IAlertWithProgressBar } from '../notifications/SnackbarProviderWithStyles';
import { ModalWithStyles } from './ModalWithStyles';

export function DeleteNumberModal(props: {
  refetchBusinessNumbers: () => void;
  setSelectedToggle: React.Dispatch<React.SetStateAction<boolean>>;
  enqueueSnackbarWithStyles: (
    alertComponentProps: IAlertWithProgressBar,
    snackbarProps?: OptionsObject | undefined
  ) => SnackbarKey | null;
  selected: GridRowData[];
  show: boolean;
  // eslint-disable-next-line @typescript-eslint/ban-types
  userAtom: Loadable<{} | IUserAtom>;
  mutation: UseMutationResult<
    AxiosResponse<any>,
    unknown,
    {
      endpoint: string;
      payload?:
        | {
            [key: string]: any;
          }
        | undefined;
      method?: Method | undefined;
      omitBusinessIdAndApikey?: boolean | undefined;
      domain?: string | undefined;
      stage?: 'itn' | 'app' | 'auto' | 'crm' | 'utils' | 'tele';
    },
    unknown
  >;
  handleClose: () => void;
}) {
  return (
    <Formik
      onSubmit={async (values, actions) => {
        if (props.selected.length) {
          let errors = false;
          props.setSelectedToggle((prev) => !prev);
          for (let i = 0; i < values.selected.length; i++) {
            const data = {
              role: props.userAtom?.contents?.user?.role,
              call: methodNameEnum.DELETE_NUMBER,
              apikey:
                props.userAtom.state === 'hasValue' &&
                'apikey' in props.userAtom.contents &&
                props.userAtom.contents.apikey,
              businessid:
                props.userAtom.state === 'hasValue' &&
                'businessid' in props.userAtom.contents &&
                props.userAtom.contents.businessid,
              numberid: values.selected[i].Numberid,
            };
            const response = await props.mutation.mutateAsync({
              endpoint: endpointEnum.DELETE_NUMBER,
              payload: data,
            });
            if (!response?.data?.success) {
              errors = true;
              break;
            }
          }
          if (!errors) {
            props.enqueueSnackbarWithStyles({
              message: `Successfully Deleted ${values.selected.length} Number(s)`,
              alertProps: { severity: 'success' },
            });
          } else {
            props.enqueueSnackbarWithStyles({
              message:
                'Looks like we encountered an error deleting these Number(s)',
              alertProps: { severity: 'error' },
            });
          }
          props.refetchBusinessNumbers();
          props.handleClose();
          actions.resetForm({});
        }
      }}
      enableReinitialize={true}
      initialValues={{ selected: props.selected ?? [] }}
    >
      {(formik) => (
        <>
          <ModalWithStyles
            onSubmit={formik.handleSubmit}
            title="Delete Number(s)"
            aria-labelledby="example-modal-sizes-title-md"
            show={props.show}
            onHide={props.handleClose}
            isSubmitting={formik.isSubmitting}
            isLoading={formik.isSubmitting}
            deleteDialog={true}
            size="xs"
          >
            <p>
              You are about to delete {formik.values.selected.length} Number(s),
              this procedure is not reversible.
            </p>
            <p> Do you want to proceed?</p>
          </ModalWithStyles>
        </>
      )}
    </Formik>
  );
}
